import { jsx as _jsx } from "react/jsx-runtime";
import { ArchivedTable } from '@widgets/archivedTable';
export function ArchivedPage() {
    return _jsx(ArchivedTable, {});
}
